import { makeStyles } from "@fluentui/react-components";
import { designTokens } from "theme/customTheme";

export const useStyles = makeStyles({
  dialogSurface: {
    width: "60vw !important" as any,
    maxWidth: "60vw !important" as any,
    minWidth: "60vw",
    height: "85vh",
    maxHeight: "85vh",
    padding: 0,
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
  },
  dialogSurfaceMobile: {
    width: "100vw !important" as any,
    maxWidth: "100vw !important" as any,
    minWidth: "100vw",
    height: "90vh",
    maxHeight: "90vh",
    padding: 0,
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
  },
  dialogBody: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
    padding: 0,
    overflow: "hidden",
  },
  dialogContent: {
    flex: 1,
    padding: 0,
    minHeight: 0,
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
  },
  dialogTitle: {
    backgroundColor: designTokens.neutral[50],
  },
  headerContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
  },
  headerLeft: {
    display: "flex",
    alignItems: "center",
    gap: designTokens.spacing[3],
  },
  headerIcon: {
    fontSize: designTokens.fontSize["2xl"],
    color: designTokens.accent[500],
  },
  knowledgeBar: {
    display: "flex",
    alignItems: "center",
    gap: designTokens.spacing[2],
    padding: `${designTokens.spacing[2]} ${designTokens.spacing[4]}`,
    backgroundColor: designTokens.neutral[100],
    borderBottom: `1px solid ${designTokens.neutral[200]}`,
    flexShrink: 0,
  },
  knowledgeText: {
    fontSize: designTokens.fontSize.sm,
    color: designTokens.neutral[600],
    marginRight: designTokens.spacing[2],
  },
  messagesArea: {
    flex: 1,
    overflowY: "auto",
    overflowX: "hidden",
    backgroundColor: designTokens.neutral.white,
    minHeight: 0,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  messagesContainer: {
    width: "100%",
    maxWidth: "800px",
    padding: `${designTokens.spacing[5]} ${designTokens.spacing[4]}`,
    display: "flex",
    flexDirection: "column",
    gap: designTokens.spacing[3],
  },
  messageDetails: {
    display: "flex",
    flexDirection: "column",
    alignItems: "start",
    gap: designTokens.spacing[2],
    width: "100%",
  },
  assistantMessage: {
    alignItems: "start",
  },
  userMessage: {
    alignItems: "end",
  },
  messageContent: {
    position: "relative",
    padding: `${designTokens.spacing[2]} ${designTokens.spacing[3]}`,
    boxSizing: "border-box",
    wordBreak: "break-word",
    color: designTokens.neutral[900],
    lineHeight: "1.6",
    width: "100%",
    "& code": {
      whiteSpace: "pre-wrap",
      wordWrap: "break-word",
      maxWidth: "100%",
      display: "block",
      backgroundColor: designTokens.neutral.white,
      padding: designTokens.spacing[2],
      borderRadius: designTokens.borderRadius.sm,
      overflowX: "auto",
    },
    "& pre": {
      whiteSpace: "pre-wrap",
      wordWrap: "break-word",
      maxWidth: "100%",
      backgroundColor: designTokens.neutral.white,
      padding: designTokens.spacing[2],
      borderRadius: designTokens.borderRadius.sm,
      overflowX: "auto",
    },
  },
  assistantMessageContent: {
    textAlign: "start",
  },
  userMessageContent: {
    textAlign: "end",
  },
  filesColumn: {
    display: "flex",
    flexWrap: "wrap",
    gap: designTokens.spacing[2],
    marginTop: designTokens.spacing[2],
  },
  fileCardFit: {
    width: "fit-content",
    maxWidth: "300px",
  },
  sourceDocCard: {
    marginTop: designTokens.spacing[2],
    padding: designTokens.spacing[3],
  },
  sourceDocContent: {
    marginTop: designTokens.spacing[2],
  },
  cursorPointer: {
    cursor: "pointer",
  },
  citationText: {
    marginLeft: designTokens.spacing[2],
  },
  editInput: {
    width: "100%",
    marginTop: designTokens.spacing[2],
  },
  editActions: {
    display: "flex",
    gap: designTokens.spacing[2],
    justifyContent: "flex-end",
    marginTop: designTokens.spacing[2],
  },
  mainWrapper: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    backgroundColor: designTokens.neutral.white,
    padding: `${designTokens.spacing[3]} ${designTokens.spacing[2]}`,
    flexShrink: 0,
    marginTop: "auto",
  },
  mainContainer: {
    display: "flex",
    flexDirection: "column",
    gap: designTokens.spacing[2],
    width: "90%",
    maxWidth: "90%",
    boxSizing: "border-box",
  },
  fieldContainer: {
    display: "flex",
    flexDirection: "column",
    gap: designTokens.spacing[2],
    marginBottom: designTokens.spacing[2],
    width: "100%",
    maxWidth: "100%",
    boxSizing: "border-box",
  },
  inputContainer: {
    display: "flex",
    alignItems: "center",
    backgroundColor: designTokens.neutral.white,
    gap: designTokens.spacing[1],
    width: "100%",
    maxWidth: "100%",
    border: `2px solid ${designTokens.neutral[300]}`,
    borderRadius: designTokens.borderRadius["2xl"],
    boxShadow: designTokens.shadow.md,
    overflow: "hidden",
    boxSizing: "border-box",
    paddingLeft: designTokens.spacing[2],
    ":focus-within": {
      border: `2px solid ${designTokens.accent[500]}`,
    },
  },
  helperText: {
    fontSize: designTokens.fontSize.xs,
    color: designTokens.neutral[400],
    textAlign: "right",
    paddingTop: designTokens.spacing[1],
    paddingRight: designTokens.spacing[2],
  },
  skeletonContent: {
    display: "flex",
    flexDirection: "column",
    gap: designTokens.spacing[2],
    width: "100%",
    padding: `${designTokens.spacing[2]} ${designTokens.spacing[3]}`,
  },
  exitButton: {
    marginRight: designTokens.spacing[1],
  },
});
